<!--

    Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
    Ministerpräsidenten des Landes Schleswig-Holstein
    Staatskanzlei
    Abteilung Digitalisierung und zentrales IT-Management der Landesregierung

    Lizenziert unter der EUPL, Version 1.2 oder - sobald
    diese von der Europäischen Kommission genehmigt wurden -
    Folgeversionen der EUPL ("Lizenz");
    Sie dürfen dieses Werk ausschließlich gemäß
    dieser Lizenz nutzen.
    Eine Kopie der Lizenz finden Sie hier:

    https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12

    Sofern nicht durch anwendbare Rechtsvorschriften
    gefordert oder in schriftlicher Form vereinbart, wird
    die unter der Lizenz verbreitete Software "so wie sie
    ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
    ausdrücklich oder stillschweigend - verbreitet.
    Die sprachspezifischen Genehmigungen und Beschränkungen
    unter der Lizenz sind dem Lizenztext zu entnehmen.

-->
<div class="flex shrink-0 gap-2">
  <ods-button
    variant="ghost"
    size="fit"
    icon="edit"
    [tooltip]="'Gerät ' + deviceName() + ' umbenennen'"
    tooltipAriaType="aria-label"
    [dataTestId]="'rename-device-' + (deviceName() | convertForDataTest) + '-button'"
    data-test-id="rename-device-ods-button"
    (clicked)="renameDialog.open()"
  />
  <ods-button
    variant="ghost"
    size="fit"
    icon="delete"
    destructive="true"
    [tooltip]="'Gerät ' + deviceName() + ' löschen'"
    tooltipAriaType="aria-label"
    [dataTestId]="'delete-device-' + (deviceName() | convertForDataTest) + '-button'"
    data-test-id="delete-device-ods-button"
    (clicked)="deleteDialog.open()"
  />
</div>

<administration-rename-device-dialog
  #renameDialog
  data-test-id="rename-device-dialog"
  [deviceLabel]="deviceLabel()"
  [stateResource]="renameStateResource()"
  (renamed)="renamed.emit($event)"
/>
<administration-delete-device-dialog
  #deleteDialog
  data-test-id="delete-device-dialog"
  [deviceName]="deviceName()"
  [stateResource]="deleteStateResource()"
  (confirmed)="deleted.emit()"
/>
